import io from 'socket.io-client'
import {BASE_URL} from './config'
import {deepClone} from './util'
import store from '../../store/index'

export const socket = {
  userId: null,
  socket: null,
  // 建立连接以及监听
  init (token) {
    this.socket = io.connect(BASE_URL, { forceNew: true , query: {auth_token: token}})

    // 监听用户上线
    this.socket.on('onLine', (data) => {

    });

    // 监听用户下线
    this.socket.on('offLine', (data) => {

    });

    // 监听消息发送
    this.socket.on('chat', (data) => {
      store.dispatch('receiveChatMessage', data)
    });

    // 会话状态更新
    this.socket.on('updateStatus', (data) => {
      store.dispatch('updateOtherConversationStatus', data)
    });
  },
  close () {
    this.socket.close();
  },
  // 方法
  sendMessage (message,fileData) {

    let param = deepClone(message);

    if (fileData) {
      let content = param.content;
      content.fileData = fileData;
      param.content = content;
    }

    this.socket.emit('chat', param, (data) => {
      console.log(data);

      message.timestamp = data.timestamp;
      message.msg_id = data.msg_id;
      if (fileData) {
        let content = data.msg_content;
        message.msg_content.fileRemotePath = content.fileRemotePath;
        message.msg_content.thumbnailRemotePath = content.thumbnailRemotePath;
      }

      store.commit('UPDATE_CHAT_MESSAGE',message)

    });
  },
  updateStatus (param) {
    this.socket.emit('updateStatus', param, (data) => {
      console.log(data);
    });
  }

};




// WEBPACK FOOTER //
// ./src/common/im/socket.js